import { render, staticRenderFns } from "./proxyConfig.vue?vue&type=template&id=820daa00&scoped=true&"
import script from "./proxyConfig.vue?vue&type=script&lang=js&"
export * from "./proxyConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820daa00",
  null
  
)

export default component.exports